
import './App.css';
import MainRoutes from './MainRoutes/MainRoutes';
import Navbar from './Components/navbar/Navbar';

function App() {
  return (
    <div className="App">
      <Navbar/>
     <MainRoutes/>
    </div>
  );
}

export default App;
